<template>
    <div class="email-listing__pagination">
        <div class="email-listing__pagination-limit">
            <span class="typographies-paragraph-small-bold">
                {{ $t.__('ListingWrapper.pagination_text') }}
            </span>
            <CompassSelect
                :modelValue="pagination.limit"
                menuClass="email-listing__pagination-select-menu"
                class="email-listing__pagination-select"
                size="small"
                @update:modelValue="handleLimitChange"
            >
                <CompassDropdownOption
                    v-for="(option, index) in paginationLimitOptions"
                    :key="index"
                    :value="option"
                    :label="option.toString()"
                />
            </CompassSelect>
        </div>
        <div class="email-listing__pagination-navigation">
            <CompassIconButton
                size="small"
                icon="caret-left"
                :disabled="isPreviousPageDisabled"
                @click="previousPage"
            />
            <span v-if="displayTotalResults" class="typographies-paragraph-small-bold">
                {{ textPagination }}
            </span>
            <CompassIconButton
                size="small"
                icon="caret-right"
                :disabled="isNextPageDisabled"
                @click="nextPage"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isLoading: {
            type: Boolean,
            required: true,
        },
        displayTotalResults: {
            type: Boolean,
            default: true,
        },
        pagination: {
            type: Object,
            required: true,
        },
        paginationLimitOptions: {
            type: Array,
            default: () => [25, 50, 75, 100],
        },
    },
    data() {
        return {
            pageCount: 1,
            previousOffset: null,
            nextOffset: null,
            listPreviousOffset: [null],
        };
    },
    computed: {
        count() {
            if (this.pageCount === 1) {
                return 1;
            }

            return (this.pageCount - 1) * this.pagination.limit + 1;
        },
        endCount() {
            let endCount =
                this.count < this.pagination.total
                    ? this.pageCount * this.pagination.limit
                    : this.pagination.total;
            if (this.pagination.total < this.pagination.limit || endCount > this.pagination.total) {
                endCount = this.pagination.total;
            }
            return endCount;
        },
        textPagination() {
            return this.$t.__('common.pagination.count_page', {
                currentPage: this.count,
                currentItemsCount: this.endCount,
                totalItems: this.pagination.total,
            });
        },
        isPreviousPageDisabled() {
            if (this.isLoading) {
                return true;
            }
            return this.pageCount === 1;
        },
        isNextPageDisabled() {
            if (this.isLoading) {
                return true;
            }
            return (
                this.pagination.limit > this.pagination.total ||
                this.endCount === this.pagination.total
            );
        },
    },
    methods: {
        handleLimitChange(newLimitvalue) {
            this.listPreviousOffset = [null];
            this.$emit('update-pagination', {
                ...this.pagination,
                limit: newLimitvalue,
                offset: null,
            });
            this.pageCount = 1;
        },
        previousPage() {
            this.pageCount -= 1;
            this.$emit('update-pagination', {
                ...this.pagination,
                offset: this.listPreviousOffset[this.pageCount - 1],
            });
        },
        nextPage() {
            if (
                this.listPreviousOffset.findIndex((offset) => offset === this.pagination.offset) ===
                -1
            ) {
                this.listPreviousOffset.push(this.pagination.offset);
            }

            this.pageCount += 1;

            this.$emit('update-pagination', this.pagination);
        },
    },
};
</script>

<style lang="scss" scoped>
.email-listing {
    &__pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        gap: var(--spacing-6);
        color: var(--colors-common-text-subtle-default);
        padding: var(--spacing-2) var(--spacing-4);
        background-color: var(--colors-common-background-default);
        width: 100%;

        &-select {
            width: 60px;
        }

        &-navigation {
            display: flex;
            gap: var(--spacing-3);
        }

        &-limit > :first-child {
            margin-right: var(--spacing-1);
        }
    }
}
</style>

<style lang="scss">
.email-listing__pagination-select-menu {
    max-width: 120px;
}
</style>
